import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../App";
import axios from "axios";
import { Button } from "./ui/button";
import { MessageCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const WS_URL = BACKEND_URL.replace('https://', 'wss://').replace('http://', 'ws://');

const MessageBell = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const [featureAvailable, setFeatureAvailable] = useState(true);
  const wsRef = useRef(null);

  useEffect(() => {
    if (!user || !featureAvailable) return;
    
    fetchUnreadCount();
    
    // Connect to WebSocket for real-time updates
    try {
      wsRef.current = new WebSocket(`${WS_URL}/api/ws/messages/${user.user_id}`);
      
      wsRef.current.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.type === "new_message") {
          setUnreadCount(prev => prev + 1);
        }
      };
      
      wsRef.current.onerror = () => {
        // Silently fail if messaging feature is not available
      };
    } catch (e) {
      // WebSocket connection failed - feature might not be deployed
    }
    
    // Poll for unread count every 30 seconds
    const interval = setInterval(fetchUnreadCount, 30000);
    
    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
      clearInterval(interval);
    };
  }, [user, featureAvailable]);

  const fetchUnreadCount = async () => {
    try {
      const response = await axios.get(`${API}/messages/unread-count`, { withCredentials: true });
      setUnreadCount(response.data.unread_count || 0);
    } catch (error) {
      // Silently fail - feature might not be deployed yet
      // 401 = not authenticated, 403 = not authorized, 404 = endpoint not found
      if (error.response?.status === 401 || error.response?.status === 403 || error.response?.status === 404) {
        setFeatureAvailable(false); // Stop polling
      }
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      className="relative"
      onClick={() => navigate("/mesajlar")}
      data-testid="message-bell"
    >
      <MessageCircle className="w-5 h-5 text-[#4B5563]" />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#1A4D2E] text-white text-xs rounded-full flex items-center justify-center">
          {unreadCount > 9 ? "9+" : unreadCount}
        </span>
      )}
    </Button>
  );
};

export default MessageBell;
